import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

import {
  KAMServicing,
  NavLinkList,
  NavLinkList_area_manager,
  NavLinkList_territory_manager,
  NavKAMList,
  NavLinkList__super_user,
  NavLinkList__online_user,
  NavLinkList__cluster_manager,
  NavLinkList__agency_manager,
  NavLinkList__QC,
} from "./linkConfig";

class SignedInLinks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      navigation_links__operation_links_sm: "navigation-desktop",
    };
  }

  MenuNavLink = (navLinkList) =>
    navLinkList.map((item, index) => (
      <li
        key={index}
        className="navigation-link"
        onClick={() => this.props.updateSelectedMenu(index)}
      >
        <NavLink
          to={item.to}
          className={`collection-item ${
            parseInt(this.props.selectedMenu) === parseInt(index)
              ? "active-menu"
              : ""
          }`}
          key={index}
        >
          <div className="link-description">
            <i className="material-icons">{item.icon}</i>
            <span className="link-description-name">{item.name}</span>
          </div>
        </NavLink>
      </li>
    ));

  render() {
    const localUserType = JSON.parse(localStorage.getItem("currUserType"));
    const portalType = JSON.parse(localStorage.getItem("portal"));
    const scope = localStorage.getItem("scope");
    const userName = localStorage.getItem("username")
      ? localStorage.getItem("username")
      : "";

    return (
      <>
        <div className={`${this.state.navigation_links__operation_links_sm}`}>
          <ul className="navigation-links">
            {/* {portalType === "kam" && this.MenuNavLink(NavKAMList)} */}
            {scope === "online"
              ? this.MenuNavLink(NavLinkList__online_user)
              : localUserType === "bkash_user"
              ? this.MenuNavLink(NavLinkList__QC)
              : localUserType === "bkash-super-user"
              ? this.MenuNavLink(NavLinkList__super_user)
              : localUserType === "area_manager"
              ? this.MenuNavLink(NavLinkList_area_manager)
              : localUserType === "territory_manager"
              ? this.MenuNavLink(NavLinkList_territory_manager)
              : localUserType === "cluster_manager"
              ? this.MenuNavLink(NavLinkList__cluster_manager)
              : localUserType === "merchant_management" ||
                localUserType === "trade_merketing"
              ? this.MenuNavLink(KAMServicing)
              : localUserType === "agency_user"
              ? this.MenuNavLink(NavLinkList__agency_manager)
              : portalType === "kam"
              ? this.MenuNavLink(NavKAMList)
              : this.MenuNavLink(NavLinkList)}
          </ul>
          {this.props.variation !== "landing" && (
            <ul className="operation-links">
              <li style={{ marginRight: "37px" }} className="signout-link">
                <NavLink to="/signout">Sign Out</NavLink>
              </li>
            </ul>
          )}
        </div>
        <ul className="navigation-dropdown-button">
          <li
            onClick={() =>
              this.setState({
                navigation_links__operation_links_sm:
                  this.state.navigation_links__operation_links_sm ===
                  "navigation-desktop"
                    ? "navigation-mobile"
                    : "navigation-desktop",
              })
            }
            style={{ width: "20px", marginRight: "20px", cursor: "pointer" }}
          >
            <i className="material-icons">
              {this.state.navigation_links__operation_links_sm ===
              "navigation-desktop"
                ? "format_list_bulleted "
                : "close"}
            </i>
          </li>
        </ul>
      </>
    );
  }
}

const mapSTateToProps = (state) => {
  return {
    authError: state.auth.authError,
    authToken: state.auth.authToken,
    filterHide: state.filter.filterHide,
  };
};

export default connect(mapSTateToProps)(SignedInLinks);
